<template>
    <span class="ma-0 pa-0">
        <v-btn @click="deleteAction" small text v-if="onlyDelete" color="error">
<!--                    <v-icon small>mdi-close-circle</v-icon>-->
          DELETE
        </v-btn>
        <v-menu bottom left offset-y v-else="!onlyDelete">
            <template v-slot:activator="{ on, attrs }">
                <v-btn small icon v-bind="attrs" v-on="on">
                    <v-icon small>mdi-dots-vertical</v-icon>
                </v-btn>
            </template>
            <v-list>
                <v-list-item v-for="item in items" @click="userAction(item)" dense :key="item.action">
                <span class="text--bold-14" :style="{color:item.color}">
                    <v-icon :color="item.color" v-if="item.icon!=undefined" small
                            class="mr-2">{{item.icon}}
                    </v-icon>{{item.text}}
                </span>
                </v-list-item>
                <v-list-item @click="editAction" dense v-if="!hideEdit">
                <span class="text--bold-14">
                    <v-icon small
                            class="mr-2">mdi-file-document-edit-outline
                    </v-icon>编辑
                </span>
                </v-list-item>
                <v-list-item @click="deleteAction" dense v-if="!hideDelete">
                <span class="text--bold-14" style="color: red">
                    <v-icon color="red" small class="mr-2">mdi-alert
                    </v-icon>删除
                </span>
                </v-list-item>
            </v-list>
        </v-menu>
    </span>
</template>
<script>
    export default {
        name: "apm-edit-delete-group",
        props: {
            items: {
                type: Array,
                default: function () {
                    return [];
                }
            },
            hideEdit: {
                type: Boolean,
                default: false
            },
            hideDelete: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                onlyDelete: false
            }
        },
        created() {
            if (!this.hideDelete && this.hideEdit && this.items.length == 0) {
                this.onlyDelete = true;
            }
        },
        methods: {
            editAction() {
                this.$emit("edit");
            },
            deleteAction() {
                this.$emit("delete");
            },
            detailAction() {
                this.$emit("detail");
            },
            userAction(item) {
                this.$emit(item.action);
                this.$emit('userAction', item.action);
            }
        }
    };
</script>
